export default "__VITE_ASSET__CRFtHFrm__"